import { render, staticRenderFns } from "./moment-setting.vue?vue&type=template&id=b8f22fb0&scoped=true"
import script from "./moment-setting.vue?vue&type=script&lang=js"
export * from "./moment-setting.vue?vue&type=script&lang=js"
import style0 from "./moment-setting.vue?vue&type=style&index=0&id=b8f22fb0&prod&lang=less&scoped=true"
import style1 from "./moment-setting.vue?vue&type=style&index=1&id=b8f22fb0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f22fb0",
  null
  
)

export default component.exports